import { useEffect, useRef, useState } from "react";
import DOCOnlineBody from "./DOCOnlineBody";
import { useTranslation } from "react-i18next";

import { GenerateDocOnlineCtr } from "./Controllers/GeneratedDocOnlineCtr";
import { ConsultantDocOnlineCtr } from "./Controllers/ConsultantDocOnlineCtr";
import { DocOnlineCtr } from "./Controllers/DocOnlineCtr";
import DocOnlineNavbar from "../../../containers/DocOnlineNavbar/DocOnlineNavbar";

const GetEditDocOnlineController = (props) => {
  if (props.match.params.docOnlineLanguageId)
    return GenerateDocOnlineCtr(props);
  else if (props.match.params.docOnlineticket) {
    return ConsultantDocOnlineCtr(props);
  } else return DocOnlineCtr(props);
};

const DOCOnlineEdit = (props) => {
  const [company, setCompany] = useState();
  let { i18n } = useTranslation();

  const { t } = useTranslation();
  let docOnlineController = useRef();
  useEffect(() => {
    document.title = t("AtVitae - DOC Online");
    if (props.match.params.docOnlineticket) {
      if (!company) {
        i18n.changeLanguage(props.match.params.languageCode);
        setCompany(props.match.params.company);
      }
    }
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  const [downloadDocOnline, setDownloadDocOnline] = useState({
    docOnlineId: 0,
    companyId: 0,
    languageId: 0,
    downloadIsInPdf: false
  });
  const [docOnline, setDocOnline] = useState({
    id: 0,
    title: "",
    companyId: 0,
    companyAbbreviation: "",
    personalInformation: {
      fullName: "",
      birthDate: "",
      jobRoleId: 0,
      gitHub: "",
      hobbies: ""
    },
    educationAndTraining: [{}],
    motherLanguage: 0,
    otherLanguages: [{}],
    workExperience: [{}],
    competences: [],
    otherCompetences: [],
    description: ""
  });

  useEffect(() => {
    let _docOnlineController = GetEditDocOnlineController(props);
    docOnlineController.current = _docOnlineController;

    setIsLoading(true);
    _docOnlineController.getDocOnline().then((data) => {
      loadDocOnline(data);
      setIsLoading(false);
    });
  }, []);

  const fillDownloadDocOnlineObject = (companyId, docOnlineId) => {
    setDownloadDocOnline((previousDownloadDocOnline) => ({
      ...previousDownloadDocOnline,
      companyId: companyId,
      docOnlineId: docOnlineId
    }));
  };
  function loadDocOnline(data) {
    if (!data.error) {
      let _docOnline = { ...docOnline };
      _docOnline.id = data.id;
      _docOnline.isAcceptedConsent = data.isAcceptedConsent;
      _docOnline.companyId = data.companyId;
      _docOnline.personalInformation = data.personalInformation;
      _docOnline.companyAbbreviation = data.companyAbbreviation;
      _docOnline.description = data.description;

      if (
        data.docEducations === undefined ||
        Object.keys(data.docEducations).length === 0
      ) {
        _docOnline.educationAndTraining = [{}];
      } else {
        _docOnline.educationAndTraining = data.docEducations;
      }

      if (
        data.docWorkExperiences === undefined ||
        Object.keys(data.docWorkExperiences).length === 0
      ) {
        _docOnline.workExperience = [{}];
      } else {
        _docOnline.workExperience = data.docWorkExperiences;
      }

      _docOnline.motherLanguage = data.motherLanguageId;

      if (data.docLanguages.length !== 0)
        _docOnline.otherLanguages = data.docLanguages;
      else _docOnline.otherLanguages = [];

      _docOnline.competences = data.competences;
      _docOnline.otherCompetences = data.otherCompetences;
      setDocOnline(_docOnline);
      fillDownloadDocOnlineObject(_docOnline.companyId, _docOnline.id);
    }
  }
  return (
    <>
      <div>
        {docOnlineController.current && (
          <>
            {props.match.params.docOnlineticket && (
              <DocOnlineNavbar candidacyCompany={company} />
            )}
            <DOCOnlineBody
              docOnline={docOnline}
              isLoading={isLoading}
              setDocOnline={setDocOnline}
              downloadDocOnline={downloadDocOnline}
              setDownloadDocOnline={setDownloadDocOnline}
              interviewId={props.match.params.interviewId}
              docOnlineLanguageId={props.match.params.docOnlineLanguageId}
              docOnlineController={docOnlineController.current}
            />
          </>
        )}
      </div>
    </>
  );
};

export default DOCOnlineEdit;
